<template>
  <el-container class="main-container">
    <div class="menu-wrapper" :class="{ active: menuVisible }">
      <div class="menu-container">
        <div class="dashboard" @click="goToDashboard">
          <div class="dashboard-icon">
            <img src="../assets/img/dashboard.png" />
          </div>

          <div class="dashboard-text">进入数字版</div>
        </div>

        <div class="menu-scroll" :class="{ active: menuVisible }">
          <div style="width: 100%; padding: 5px">
            <r-menu-item
              v-for="(item, index) in menus"
              v-if="item.enable"
              :icon="item.icon"
              :to="item.to"
              :title="item.title"
              :key="index"
            ></r-menu-item>
          </div>
        </div>
        <br />
      </div>
      <div
        class="menu-switch"
        :class="{ hidden: !menuVisible }"
        @click="toggleMenu"
        :style="{ display: oss && $route.name === 'ceBao123' ? 'none' : '' }"
      >
        <i
          class="menuicon"
          :class="menuVisible ? 'menuicon-left' : 'menuicon-right'"
        ></i>
      </div>
    </div>

    <el-main class="content-container" :class="{ active: menuVisible }">
      <router-view class="right-content-box"></router-view>
    </el-main>
  </el-container>
</template>
<style lang="scss">
.main-container {
  height: calc(100vh - var(--header-height));

  .menu-wrapper {
    /*background-color: #1b93ed;*/
    width: var(--menu-width);
    height: 100%;
    position: relative;
    left: calc(var(--menu-width) * -1);
    transition: left 0.5s;
    -moz-transition: left 0.5s;
    -webkit-transition: left 0.5s;
    -o-transition: left 0.5s;
    &.active {
      left: 0;
    }

    .menu-container {
      height: 100%;
      width: var(--menu-width);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .dashboard {
        flex-shrink: 0;
        height: calc(var(--header-bg-height) - var(--header-height));
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin-bottom: var(--space);

        &-icon {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background-color: var(--primary-color);
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 60%;
          }
        }

        &-text {
          width: 100px;
          height: 36px;
          border-radius: 50px;
          background-color: var(--primary-color);
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          margin-top: 20px;
        }
      }

      .menu-scroll {
        width: 100%;
        // height: calc(100vh - var(--header-bg-height) - var(--space));
        flex-grow: 1;
        overflow-y: auto;
        box-sizing: border-box;
      }
    }
    .menu {
      width: var(--menu-width);
      height: 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      left: calc(var(--menu-width) * -1);
      padding: 0 5px 0 10px;
      background-color: #1b93ed;
      box-sizing: border-box;
      z-index: 99;
      transition: left 0.5s;
      -moz-transition: left 0.5s;
      -webkit-transition: left 0.5s;
      -o-transition: left 0.5s;
    }
    .menu.active {
      left: 0;
    }
    .menu-switch {
      position: absolute;
      top: 50%;
      height: 40px;
      width: 20px;
      left: 0;
      border-top-right-radius: 1.5rem;
      border-bottom-right-radius: 1.5rem;
      background-color: #1b93ed;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 3;
      transition: all 0.3s;

      .menuicon {
        color: #fff;
        font-size: 16px;
        font-weight: 700;
      }

      &.hidden {
        left: var(--menu-width);
      }
    }
  }

  .content-container {
    position: absolute;
    padding: 0;
    top: 0;
    bottom: 0;
    right: var(--space);
    left: 25px;
    transition: left 0.5s;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0px 0px 20px 0px #00000014;
    -moz-transition: left 0.5s;
    -webkit-transition: left 0.5s;
    -o-transition: left 0.5s;
    &.active {
      left: var(--menu-width);
    }
  }
  .router-view-outer-wrapper {
    position: relative;
    height: 100%;
    .router-bottom {
      position: absolute;
      bottom: 0;
    }
  }
  .el-footer {
    /*background-color: #1b93ed;*/
    font-size: 14px;
    width: 100%;
    height: 20px !important;
    text-align: center;
    margin-top: 50px;
    a {
      text-decoration: none;
      color: #1b93ed;
    }
  }
}

.right-content-box {
  position: absolute;
  left: 0rem;
  top: 0;
  right: 0;
  bottom: 0;
  padding: var(--space);
  overflow-y: auto;
}
</style>
<script>
import RMenuItem from "./MenuItem";
export default {
  components: { RMenuItem },
  data() {
    let userlevel = this.getCookie("level");
    return {
      menuVisible: false,
      menus: [
        {
          title: "总览",
          icon: require("../assets/img/menus/region.png"),
          to: "/main/region",
          enable: false,
        },
        {
          title: "实时动态",
          icon: require("../assets/img/menus/realTime.png"),
          to: "/main/realTime",
          enable: false,
        },
        {
          title: "测报123",
          icon: require("../assets/img/menus/ceBao123.png"),
          to: "/main/ceBao123",
          enable: false,
        },
        {
          title: "地理信息",
          icon: require("../assets/img/menus/map.png"),
          to: "/main/map",
          enable: false,
        },
        {
          title: "捕虫分布",
          icon: require("../assets/img/menus/trapperMap.png"),
          to: "/main/trapperMap",
          enable: false,
        },
        // {
        //   title: '预警信息',
        // icon: require("../assets/img/menus/region.png"),
        //   to: '/main/mapWarning',
        //   enable: true
        // },
        {
          title: "数据统计",
          icon: require("../assets/img/menus/compare.png"),
          to: "/main/compare",
          enable: false,
        },
        {
          title:
            userlevel == 102 || userlevel == 103 ? "权限管理" : "测报点信息",
          icon: require("../assets/img/menus/detectPoints.png"),
          to: "/main/detectPoints",
          enable: false,
        },
        {
          title: "昆虫信息库",
          icon: require("../assets/img/menus/insectRepo.png"),
          to: "/main/insectRepo",
          enable: false,
        },
        {
          title: "网关列表",
          icon: require("../assets/img/menus/equipment.png"),
          to: "/main/equipment",
          enable: false,
        },
        {
          title: "区域邻居",
          icon: require("../assets/img/menus/neighborArea.png"),
          to: "/main/neighborArea",
          enable: false,
        },
        {
          title: "昆虫预测",
          icon: require("../assets/img/menus/forecast.png"),
          to: "/main/forecast",
          enable: false,
        },
        {
          title: "日志审计",
          icon: require("../assets/img/menus/record.png"),
          to: "/main/auditor",
          enable: false,
        },
        {
          title: "账户设置",
          icon: require("../assets/img/menus/setting.png"),
          to: "/main/setting",
          enable: false,
        },
        {
          title: "维修员管理",
          icon: require("../assets/img/menus/repair.png"),
          to: "/main/repair",
          enable: false,
        },
        {
          title: "工单管理",
          icon: require("../assets/img/menus/record.png"),
          to: "/main/workOrder",
          enable: false,
        },
        {
          title: "维修零件",
          icon: require("../assets/img/menus/material.png"),
          to: "/main/material",
          enable: false,
        },
        {
          title: "区域管理",
          icon: require("../assets/img/menus/regionalManage.png"),
          to: "/main/regionalManage",
          enable: false,
        },
        {
          title: "耕作区配置",
          icon: require("../assets/img/menus/cropArea.png"),
          to: "/main/cropArea",
          enable: false,
        },
        {
          title: "植保情报",
          icon: require("../assets/img/menus/template.png"),
          to: "/main/information/template",
          enable: false,
        },
        {
          title: "测报灯气象站",
          icon: require("../assets/img/menus/weatherStation.png"),
          to: "/main/weatherStation",
          enable: this.getCookie("name") === "jiangsuF",
        },
      ],
      minHeight: "650px",
    };
  },
  computed: {
    oss() {
      return this.$store.state.oss;
    },
  },
  created() {
    let showMenu = localStorage.getItem("menu").split(",");
    for (let item of this.menus) {
      for (let items of showMenu) {
        if (item.title === items) {
          Object.assign(item, {
            enable: this.oss && item.to === "/main/ceBao123" ? false : true,
          });
        }
      }
    }
  },
  methods: {
    goToDashboard() {
      const token = localStorage.getItem("token");
      location.href = `https://portal.nbniukang.com/auth?token=${token}&module=3&sync=1`;
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
      this.$store.dispatch("regionWidthChangedNum");
    },
  },
};
</script>



// WEBPACK FOOTER //
// menu.vue?65e83e6c